import React, { createContext, useContext } from 'react';
import { ISaleOrderDetail, IServices } from 'features/salesOrder/types';

export interface ServiceQuickEditContextValue {
	salesOrder: ISaleOrderDetail;
	originalService: IServices;
	agencyId?: number;
	requestConfirmation: (updatedPayload: Record<string, unknown>) => Promise<boolean>;
	onSaveSuccess: () => void;
}

const ServiceQuickEditContext = createContext<ServiceQuickEditContextValue | null>(null);

interface ServiceQuickEditProviderProps {
	value: ServiceQuickEditContextValue;
	children: React.ReactNode;
}

export const ServiceQuickEditProvider = ({ value, children }: ServiceQuickEditProviderProps): JSX.Element => {
	return <ServiceQuickEditContext.Provider value={value}>{children}</ServiceQuickEditContext.Provider>;
};

export const useServiceQuickEdit = (): ServiceQuickEditContextValue | null => {
	return useContext(ServiceQuickEditContext);
};
